import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Container from "../container/container";
import Tabs from "../tabs/tabs";
import Placeholder1 from "../../assets/images/emptyState/restaurant-placeholder.jpg";
import Placeholder2 from "../../assets/images/emptyState/restaurant-placeholder1.jpg";
import Placeholder3 from "../../assets/images/emptyState/restaurant-placeholder2.jpg";
import { isOutletOpen } from "../../helpers/isOutletOpen";

export default function Header({ restaurant, SearchFood }) {
  const location = useLocation();
  const { settings } = useSelector((state) => state.application);
  const foods = restaurant?.foods;

  function getFoodCategories() {
    let arr = [];
    for (let index = 0; index < foods?.length; index++) {
      const categories = foods[index].food_categories;
      // Handle array of categories
      if (Array.isArray(categories)) {
        categories.forEach((category) => {
          if (!arr.includes(category)) {
            arr.push(category);
          }
        });
      } else if (categories && !arr.includes(categories)) {
        // Fallback for single category string
        arr.push(categories);
      }
    }
    return arr;
  }

  let data = getFoodCategories();

  function selectBackgroundImage(apiImages) {
    // Predefined images to use if apiImages is empty
    const fallbackImages = [Placeholder1, Placeholder2, Placeholder3];

    // Check if apiImages array has any images
    if (apiImages?.length > 0) {
      // Randomly select one image from apiImages
      const randomIndex = Math.floor(Math.random() * apiImages?.length);
      return apiImages[randomIndex];
    } else {
      // Randomly select one of the fallback images
      const randomIndex = Math.floor(Math.random() * fallbackImages.length);
      return fallbackImages[randomIndex];
    }
  }

  const backgroundImage = selectBackgroundImage(
    restaurant?.restaurant_banners
      ? restaurant?.restaurant_banners
      : restaurant?.package_banners
  );

  // Use the API's restaurant_open when it's sent, else work it out from the hours
  const isOpen =
    typeof restaurant?.restaurant_open === "boolean"
      ? restaurant.restaurant_open
      : isOutletOpen(
          restaurant?.restaurant_operating_status,
          settings?.restaurant_operating_status,
          restaurant?.restaurant_operating_time,
          restaurant?.restaurant_time_zone
        );

  return (
    <div
      className={
        location.pathname.includes("store") &&
          !location.pathname.includes("details")
          ? ""
          : "mb-4 sm:mb-12"
      }
    >
      <div
        className="min-h-48 sm:min-h-96 bg-cover no-repeat bg-center relative z-0 dark-overlay"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
        }}
      >
        {!isOpen && restaurant && (
          <div className="absolute top-0 w-full h-full bg-black/70 flex items-center justify-center z-10">
            <div className="text-center">
              <p className="text-3xl font-bold text-white mb-3">Closed</p>
              <p className="text-lg text-white">You cannot place any orders from this restaurant at the moment</p>
            </div>
          </div>
        )}
        <Container>
          <div className="py-10 sm:py-24">
            <h2
              className="text-5xl sm:text-7xl text-white font-bold mb-3 mt-16 capitalize"
              style={{ lineHeight: "64px" }}
            >
              {restaurant?.restaurant_name
                ? restaurant?.restaurant_name
                : restaurant?.package_name}
            </h2>
            <div className="flex gap-4 mb-8 mt-[40px]"></div>
          </div>
        </Container>
      </div>

      <div
        className={
          location.pathname.includes("restaurant") &&
            !location.pathname.includes("details")
            ? "block sticky top-0"
            : "hidden mb-8"
        }
      >
        <div className="max-w-7xl mx-auto sm:px-4">
          <main className="-mt-16 pb-6 relative z-10">
            <Tabs data={data} SearchFood={SearchFood} />
          </main>
        </div>
      </div>
    </div>
  );
}
